import { render } from "./formLuckyDraw.vue?vue&type=template&id=be8671e4"
import script from "./formLuckyDraw.vue?vue&type=script&lang=js"
export * from "./formLuckyDraw.vue?vue&type=script&lang=js"

import "./formLuckyDraw.vue?vue&type=style&index=0&id=be8671e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__